import hatsApi from '@/services/hatsApi'
import _ from 'lodash'

export default {
  modifyCollections (params) {
    if (typeof params.rollingStockWagons !== 'undefined' && params.rollingStockWagons.length) {
      _.forEach(params.rollingStockWagons, (rollingStockWagon) => {
        if (rollingStockWagon.new) {
          delete rollingStockWagon.id
        }
        _.forEach(rollingStockWagon.rollingStockCoupes, (rollingStockCoupe) => {
          if (rollingStockCoupe.new) {
            delete rollingStockCoupe.id
          }
        })
      })
    }
  },
  copyRollingStock (params) {
    return hatsApi().post('/master-data/rolling-stock/copy', params)
  },
  createRollingStock (params) {
    return hatsApi().post('/master-data/rolling-stock', params)
  },
  deleteRollingStock (id) {
    return hatsApi().delete('/master-data/rolling-stock/' + id)
  },
  updateRollingStock (params) {
    this.modifyCollections(params)
    return hatsApi().put('/master-data/rolling-stock/' + params.id, params)
  },
  getRollingStock (id) {
    return hatsApi().get('/master-data/rolling-stock/' + id)
  },
  getRollingStocks (params) {
    let filter = params || ''
    return hatsApi().get('/master-data/rolling-stock/?filter=' + JSON.stringify(filter))
  },
  getRollingStockWagons (params) {
    let filter = params || ''
    return hatsApi().get('/master-data/rolling-stock-wagon/?filter=' + JSON.stringify(filter))
  },
  deleteRollingStockWagon (id) {
    return hatsApi().delete('/master-data/rolling-stock-wagon/' + id)
  },
  getMapping (params) {
    let filter = params || ''
    return hatsApi().get('/master-data/rolling-stock/mapping/?filter=' + JSON.stringify(filter))
  },
  sendAllTickets (id) {
    return hatsApi().put('master-data/rolling-stock/mail/' + id, {})
  },
  getList (id) {
    return hatsApi().put('/master-data/rolling-stock/mapping-report/' + id, {}, {'responseType': 'blob'})
  },
  getSimpleList (id) {
    return hatsApi().put('/master-data/rolling-stock/mapping-simple-report/' + id, {}, {'responseType': 'blob'})
  },
  getInternalList (id) {
    return hatsApi().put('/master-data/rolling-stock/mapping-internal-report/' + id, {}, {'responseType': 'blob'})
  },
  getCoupeList (id) {
    return hatsApi().get('/master-data/rolling-stock/coupe-list/' + id, {'responseType': 'blob'})
  },
  generateAllTickets (id) {
    return hatsApi().put('/master-data/rolling-stock/ticket/' + id, {})
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/RollingStock.js